import {Outlet, useLocation} from 'react-router-dom'
import {ContentArea} from '@/components/shared/ContentArea'
import {InlineRow} from '@/components/shared/InlineRow'
import {Plug} from 'lucide-react'
import {useAuth} from '@/contexts/auth-context'
import {usePageTitle} from '@/hooks/use-page-title'
import {useI18n} from '@/i18n'
import {SidebarNav, type SidebarNavItem} from '@/components/layout/SidebarNav'
import {SidebarNavId} from '@/testids/SidebarNavTestIds'
import {routes} from '@/lib/routes'
import {permissions} from '@/lib/permissions'
import {CONCEPT_ICON} from '@/lib/concepts'
import {EmptyState} from '@/components/shared/EmptyState'
import {SectionContainer} from '@/components/shared/SectionContainer'

interface ConnectorsMenuItem extends SidebarNavItem {
    permission: string
}

export function Connectors() {
    const i18n = useI18n()
    usePageTitle(i18n.connectorsHub.pageTitle)
    const location = useLocation()
    const {hasPermission} = useAuth()
    const isRoot = location.pathname === routes.connectors.root()

    const menuItems: ConnectorsMenuItem[] = [
        {
            id: SidebarNavId.InboundConnectors,
            href: routes.connectors.inbound.list(),
            icon: CONCEPT_ICON.connectorInbound,
            permission: permissions.inboundConnectors.view,
            title: i18n.connectorsHub.inboundTitle,
            description: i18n.connectorsHub.inboundDescription,
        },
        {
            id: SidebarNavId.OutboundConnectors,
            href: routes.connectors.outbound.list(),
            icon: CONCEPT_ICON.connectorOutbound,
            permission: permissions.outboundConnectors.view,
            title: i18n.connectorsHub.outboundTitle,
            description: i18n.connectorsHub.outboundDescription,
        },
    ]

    const visibleMenuItems = menuItems.filter(item => hasPermission(item.permission))

    return (
        <SectionContainer>
            <InlineRow align="start">
                <SidebarNav items={visibleMenuItems} aria-label={String(i18n.connectorsHub.pageTitle)}/>
                <ContentArea>
                    {isRoot ? (
                        <EmptyState
                            variant="card"
                            icon={Plug}
                            title={String(i18n.connectorsHub.welcome)}
                            description={String(i18n.connectorsHub.selectOption)}
                            data-testid="connectors-welcome-card"
                        />
                    ) : (
                        <Outlet/>
                    )}
                </ContentArea>
            </InlineRow>
        </SectionContainer>
    )
}
